import Reflux from "reflux";

const EventTableAction = Reflux.createActions(["initialLoad", "publishAsNow", "hideEvent", "showEvent", "updateEvent", "deleteEvent", "initiateRepublishing"]);

window.EventTableAction = EventTableAction;
export default EventTableAction;
